import { render, staticRenderFns } from "./ToDo.vue?vue&type=template&id=2d043854&scoped=true"
import script from "./ToDo.vue?vue&type=script&lang=js"
export * from "./ToDo.vue?vue&type=script&lang=js"
import style0 from "./ToDo.vue?vue&type=style&index=0&id=2d043854&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d043854",
  null
  
)

export default component.exports